import React, { useMemo } from "react";
import { useUserContext } from "../../utils/UserContext";
import { mapToPresentable, mapejos } from "../../utils/Mapejos";
import LlistaRecursos from "./LlistaRecursos";
import { ChipActiu, DataVenciment, MiniaturaRecurs } from "./RecursosComuns";

export const idVehicle = (v) => (v ? Number(v.idVehicles) : null);
const esActiu = (v) => Number(v.Actiu) === 1;
const tipusPresentable = (v) => mapToPresentable(v.TipusVehicle, mapejos.tipusVehicle) || "—";
const formatKm = (v) =>
  v.KmActuals === null || v.KmActuals === undefined ? "—" : `${Number(v.KmActuals).toLocaleString("ca-ES")} km`;
const text = (valor) => valor || "—";

const COLUMNES = [
  {
    key: "Imatge",
    label: "",
    senseOrdre: true,
    render: (v) => <MiniaturaRecurs imatge={v.Imatge} alt={v.Matricula} icona="🚐" />,
  },
  { key: "Matricula", label: "Matrícula", render: (v) => <strong>{v.Matricula}</strong> },
  { key: "Alies", label: "Àlies", render: (v) => text(v.Alies) },
  { key: "Marca", label: "Marca", render: (v) => text(v.Marca) },
  { key: "Model", label: "Model", render: (v) => text(v.Model) },
  { key: "TipusVehicle", label: "Tipus", sortValue: tipusPresentable, render: tipusPresentable },
  { key: "KmActuals", label: "Km actuals", num: true, render: formatKm },
  { key: "DataProperaITV", label: "Propera ITV", render: (v) => <DataVenciment data={v.DataProperaITV} /> },
  { key: "DataProperaRevisio", label: "Propera revisió", render: (v) => <DataVenciment data={v.DataProperaRevisio} /> },
  {
    key: "DataVencimentAsseguranca",
    label: "Assegurança",
    render: (v) => <DataVenciment data={v.DataVencimentAsseguranca} />,
  },
  { key: "Actiu", label: "Estat", sortValue: (v) => (esActiu(v) ? 0 : 1), render: (v) => <ChipActiu actiu={esActiu(v)} /> },
];

const textCerca = (v) => [v.Matricula, v.Marca, v.Model, v.Alies].filter(Boolean).join(" ");

const filtreFila = (v, filtres) => !filtres.tipus || v.TipusVehicle === filtres.tipus;

const renderTargeta = (v) => ({
  imatge: <MiniaturaRecurs imatge={v.Imatge} alt={v.Matricula} icona="🚐" />,
  titol: [v.Matricula, v.Alies && `(${v.Alies})`].filter(Boolean).join(" "),
  meta: [[v.Marca, v.Model].filter(Boolean).join(" "), tipusPresentable(v), esActiu(v) ? null : "Inactiu"]
    .filter((x) => x && x !== "—")
    .join(" · "),
});

const ORDRE_INICIAL = { key: "Matricula", direction: "asc" };

function Seleccionarvehicle(props) {
  const { empresaSeleccionada } = useUserContext();
  const cosPeticio = useMemo(
    () => ({ idEmpresa: empresaSeleccionada?.IdEmpresa || null }),
    [empresaSeleccionada]
  );

  const renderFiltres = ({ filtres, setFiltre, dades }) => {
    const tipus = Array.from(new Set(dades.map((v) => v.TipusVehicle).filter(Boolean)));
    return (
      <div className="dv2-filter">
        <span className="dv2-filter-label">Tipus</span>
        <select className="dv2-select" value={filtres.tipus || ""} onChange={(e) => setFiltre("tipus", e.target.value)}>
          <option value="">Tots</option>
          {tipus.map((t) => (
            <option key={t} value={t}>
              {mapToPresentable(t, mapejos.tipusVehicle)}
            </option>
          ))}
        </select>
      </div>
    );
  };

  return (
    <LlistaRecursos
      {...props}
      endpoint="Vehicles.php"
      clauDades="vehicles"
      cosPeticio={cosPeticio}
      idDe={idVehicle}
      esActiu={esActiu}
      columnes={COLUMNES}
      textCerca={textCerca}
      filtreFila={filtreFila}
      renderFiltres={renderFiltres}
      renderTargeta={renderTargeta}
      placeholderCerca="Cerca per matrícula, marca, model o àlies…"
      etiquetaPlural="vehicles"
      ordreInicial={ORDRE_INICIAL}
    />
  );
}

export default Seleccionarvehicle;
